export default __webpack_public_path__ + "static/JJ_MedicalCloud_Logo-362429efb236b2244dbc14a93677140a.svg";